import { ProviderType } from 'bzx-common/src/domain/ProviderTypeDictionary'
import * as mobx from 'mobx'
import { RootStore } from 'bzx-common/src/stores'

export default class ProviderInfoVM {
  public rootStore: RootStore

  public connect(providerType: ProviderType) {
    this.rootStore.web3Connection.connect(providerType)
  }

  public disconnect() {
    this.rootStore.web3Connection.disconnect()
  }

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
  }
}
